import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'cnxlcc_summary';
export const route = 'cnxlcc_summary/[[...params]]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "cnxlcc_summary" */
/* webpackPrefetch: true */
'../components/SummaryLCCPage')));